//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
  NotificationManager,
  NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { manageDeleteManageCrew, reset } from "./redux/slice";

const DeleteManageCrew = ({ refresh }) => {
  //Redux
  const dispatch = useDispatch();
  const { open, loading, result, error, deleteCrew, deleteCrewList } =
  useSelector((state) => state.manageDeleteManageCrewRedux);

  //Language
  const { messages } = useIntl();

  //Handlers and utils
  const handleClose = useCallback(() => dispatch(reset()), []);
  const handleDeleteSubmit = useCallback(() => {
    if (deleteCrew) {
      dispatch(manageDeleteManageCrew({ id: deleteCrew?.id }));
      return;
    }
    if (deleteCrewList?.length) {
      dispatch(manageDeleteManageCrew({ items: deleteCrewList }));
    }
  }, [deleteCrew, deleteCrewList]);

  //Effects
  useEffect(() => {
    if (!error) return;
    NotificationManager.error(
      error?.error || messages["errorMessage"],
      messages["error"],
      3000,
      null,
      null,
      "error"
    );
    dispatch(reset({ error: null }));
  }, [error]);

  useEffect(() => {
    if (!result) return;
    const messageSuccess = deleteCrew
      ? messages["manage_deletedCrew"]
      : messages["manage_deletedCrews"];
    NotificationManager.success(
      messageSuccess,
      messages["success"],
      3000,
      null,
      null,
      "success"
    );
    refresh();
    dispatch(reset());
  }, [result]);
  return (
    <Modal
      title={
        deleteCrew
          ? messages["manage_deleteManageCrew_deleteCrew"]
          : messages["manage_deleteManageCrew_deleteCrews"]
      }
      size="small"
      open={open}
      handleClose={handleClose}
      loading={loading}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button
            variant="warning"
            onClick={() => handleDeleteSubmit()}
            isDisabled={loading}
          >
            {messages["delete"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "10px 25px" }}>
        <p>{messages["manage_deleteManageCrew_confirmationMessage"]}</p>
        <ul>
          {deleteCrew ? (
            <li>
              {deleteCrew?.firstName} {deleteCrew?.lastName}
            </li>
          ) : (
            deleteCrewList.map((crew) => (
              <li>
                {crew.firstName} {crew.lastName}
              </li>
            ))
          )}
        </ul>
      </div>
      <NotificationContainer />
    </Modal>
  );
};

export default DeleteManageCrew;
